import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth, useOrganizationList } from "./clerkReact";
import { isClientRole, isInternalRole } from "../Authentication/roleAccess";

const AutoActivateOrg = () => {
  const { isLoaded: isAuthLoaded, isSignedIn, orgId } = useAuth();
  const { isLoaded: isOrgLoaded, organizationList, setActive } = useOrganizationList();
  const location = useLocation();
  const hasAttempted = useRef(false);

  useEffect(() => {
    if (hasAttempted.current) return;
    if (!isAuthLoaded || !isSignedIn || orgId) return;
    if (!isOrgLoaded || !organizationList?.length || !setActive) return;

    const isClientPath = location.pathname.startsWith("/client");
    const preferredOrg = organizationList.find((membership) => {
      if (!membership.organization?.id) return false;
      return isClientPath ? isClientRole(membership.role) : isInternalRole(membership.role);
    });
    const firstOrgId =
      preferredOrg?.organization?.id ||
      organizationList.find((membership) => membership.organization?.id)?.organization?.id ||
      null;
    if (!firstOrgId) return;

    hasAttempted.current = true;
    setActive({ organization: firstOrgId }).catch((error) => {
      hasAttempted.current = false;
      console.warn("Failed to auto-activate organization", error);
    });
  }, [isAuthLoaded, isSignedIn, orgId, isOrgLoaded, organizationList, setActive, location.pathname]);

  return null;
};

export default AutoActivateOrg;
